import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { OptionGroupType } from 'src/constants';
import { OptionGroupsResponseBody } from './types';

export const getOptionGroups = async (
  optionGroupId?: string,
  name?: string,
  limit: number = 15,
  type?: OptionGroupType[],
  ranges?: string[],
  menuId?: string,
  priceSchemeId?: string,
): Promise<OptionGroupsResponseBody> => {
  const urlWithParams = new URL(`${API_URL}/option-groups?limit=${limit}`);

  if (optionGroupId) {
    urlWithParams.searchParams.append('after_id', optionGroupId);
  }

  if (name) {
    urlWithParams.searchParams.append('name', name);
  }

  if (type?.length > 0) {
    urlWithParams.searchParams.append('type', type.join(','));
  }

  if (ranges?.length > 0) {
    urlWithParams.searchParams.append('ranges', ranges.join(','));
  }

  if (menuId) {
    urlWithParams.searchParams.append('menus', menuId);
  }

  const response = await fetch(urlWithParams.href, {
    ...(priceSchemeId ? { headers: { [PRICE_SCHEME_HEADER]: priceSchemeId } } : {}),
  });

  if (!response.ok) {
    throw new Error('We have been unable to complete your request. Please try again');
  }

  return response.json();
};
